import { getWcAjaxUrl, postWcAjax, replaceWooFragments } from './cart-ajax-client';

class SingleProductAjaxCart {
    constructor(selector = 'form.cart') {
        if (window.__spSingleProductAjaxCartInstance) return;
        window.__spSingleProductAjaxCartInstance = this;
        this.selector = selector;
        this.form = null;
        this.button = null;
        this.ajaxUrl = this.resolveAjaxUrl();
        this.isSubmitting = false;
        this.bindEvents();
    }

    resolveAjaxUrl() {
        return getWcAjaxUrl('sp_add_to_cart');
    }

    isEligible(form = this.form) {
        if (!form) return false;
        if (form.classList.contains('grouped_form')) return false;
        if ((form.method || '').toLowerCase() === 'get') return false;
        return true;
    }

    bindEvents() {
        document.addEventListener(
            'submit',
            event => {
                const form = event.target;
                if (!(form instanceof HTMLFormElement)) return;
                if (!form.matches(this.selector)) return;
                if (!this.isEligible(form)) return;
                if (form.dataset.spSubmitting === '1') return;
                event.preventDefault();
                this.form = form;
                this.button =
                    form.querySelector('.single_add_to_cart_button') || null;
                form.dataset.spSubmitting = '1';
                this.addToCart(event.submitter || this.button);
            },
            true
        );

    }

    addToCart(submitter) {
        if (!this.ajaxUrl) return;
        if (window.__spSingleProductAjaxCartBusy) return;
        if (this.isSubmitting) return;
        window.__spSingleProductAjaxCartBusy = true;
        this.isSubmitting = true;
        const data = this.buildPayload(submitter);

        if (submitter) {
            submitter.classList.add('loading');
            submitter.setAttribute('aria-busy', 'true');
        }

        postWcAjax('sp_add_to_cart', data)
            .then(response => {
                if (!response) return;
                if (!response.success) {
                    const message =
                        response.data?.message ||
                        this.extractErrorMessage(response.data?.errors) ||
                        'Nie można dodać produktu do koszyka.';
                    this.renderNotice(message, 'error');
                    return;
                }
                const data = response.data || {};
                if (data.fragments) {
                    this.replaceFragments(data.fragments);
                }
                if (data.cart_count_html) {
                    this.replaceFragments({
                        'span.header-cart-count': data.cart_count_html,
                    });
                }
                if (data.mini_cart_wrapper_html) {
                    this.replaceFragments({
                        '#mini-cart-wrapper': data.mini_cart_wrapper_html,
                    });
                }
                if (data.mini_cart_html) {
                    const wrapper = document.querySelector('#mini-cart-wrapper');
                    if (wrapper) {
                        wrapper.innerHTML = data.mini_cart_html;
                    } else {
                        const container = document.querySelector(
                            '.mini-cart__wrapper > div'
                        );
                        if (container) {
                            container.innerHTML = data.mini_cart_html;
                        }
                    }
                }
                if (window.jQuery) {
                    const $button = window.jQuery(submitter || null);
                    window.jQuery(document.body).trigger('added_to_cart', [
                        data.fragments || {},
                        data.cart_hash || '',
                        $button,
                    ]);
                }
                // rely on WooCommerce added_to_cart event only
            })
            .catch(() => {
                this.renderNotice(
                    'Wystąpił błąd podczas dodawania do koszyka.',
                    'error'
                );
            })
            .finally(() => {
                if (submitter) {
                    submitter.classList.remove('loading');
                    submitter.removeAttribute('aria-busy');
                }
                this.isSubmitting = false;
                window.__spSingleProductAjaxCartBusy = false;
                if (this.form) {
                    delete this.form.dataset.spSubmitting;
                }
            });
    }

    buildPayload(submitter) {
        const data = new URLSearchParams();
        const productId =
            this.form?.querySelector('[name="product_id"]')?.value ||
            this.form?.querySelector('[name="add-to-cart"]')?.value ||
            submitter?.value ||
            '';
        if (productId) {
            data.append('product_id', productId);
        }

        const qtyField = this.form?.querySelector('[name="quantity"]');
        const qty = qtyField?.value || '1';
        data.append('qty', qty);

        const variationId = this.form?.querySelector(
            '[name="variation_id"]'
        )?.value;
        if (variationId && variationId !== '0') {
            data.append('variation_id', variationId);
        }

        this.form
            ?.querySelectorAll('[name^="attribute_"]')
            ?.forEach(input => {
                if (!input.name) return;
                data.append(input.name, input.value);
            });

        return data;
    }

    // custom endpoint returns the needed fragments

    replaceFragments(fragments) {
        replaceWooFragments(fragments);
    }

    extractErrorMessage(errors) {
        if (!Array.isArray(errors) || !errors.length) return '';
        return errors
            .map(error => (error?.notice ? String(error.notice) : ''))
            .join(' ')
            .replace(/<[^>]*>/g, '')
            .trim();
    }

    decodeHtml(text) {
        const temp = document.createElement('div');
        temp.innerHTML = text || '';
        return temp.textContent || '';
    }

    renderNotice(message, type = 'error') {
        if (!message) return;
        let wrapper = document.querySelector('.woocommerce-notices-wrapper');
        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.className = 'woocommerce-notices-wrapper';
            const summary = document.querySelector(
                '.single-product__summary'
            );
            if (summary) {
                summary.prepend(wrapper);
            } else {
                document.body.prepend(wrapper);
            }
        }
        wrapper.innerHTML = '';
        const notice = document.createElement('div');
        notice.className =
            type === 'error' ? 'woocommerce-error' : 'woocommerce-message';
        notice.setAttribute('role', 'alert');
        notice.tabIndex = -1;
        notice.textContent = this.decodeHtml(message);
        wrapper.appendChild(notice);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new SingleProductAjaxCart();
    });
} else {
    new SingleProductAjaxCart();
}
